export default {
	back_home: '返回首頁',
	buy_now: '立即購買',
	data_disk: '資料碟',
	empty: '暫無產品',
	invoice_not_found: '發票不存在或連結已失效',
	package: '套餐',
	per_month: '/月',
	server_desc: '專用物理硬體，性能高，頻寬大，可加IP',
	server_title: '獨立物理伺服器',
	system_disk: '系統碟',
	vps_desc: '高效能，高可用，高性價比',
	vps_title: 'VPS雲伺服器',
}
